<template>
    <div class="d-flex align-items-center payroll-steps">
        <div
            v-for="step in steps"
            :key="step.key"
            class="d-flex align-items-center payroll-step"
            :class="{'is-current': step.key === current}"
        >
            <span class="payroll-step-number">{{ step.number }}</span>
            <span class="payroll-step-label">
                <span v-for="line in step.label" :key="line" class="payroll-step-label-line">{{ line }}</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    // `current` is one of the step keys below; anything else renders every step as inactive.
    props: {
        current: {
            type: String,
            default: null,
        },
        // The Salary Employees step is skipped for runs with no salaried employees
        showSalaried: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        steps() {
            const steps = [
                // Each label is split into the two lines it renders on, rather than left to wrap
                {key: 'hourly', label: ['Hourly', 'Employees']},
                {key: 'salaried', label: ['Salary', 'Employees']},
                {key: 'summary', label: ['Review', '& Submit']},
            ].filter(step => this.showSalaried || step.key !== 'salaried')
            steps.forEach((step, index) => {
                step.number = index + 1
            })
            return steps
        },
    },
}
</script>

<style lang="scss" scoped>
    // The circle is sized to match the two label lines beside it
    $step-line-height: 1.125rem;
    $step-color: #999;
    $step-color-current: #333;

    .payroll-step {
        color: $step-color;

        .payroll-step-number {
            background-color: $step-color;
        }

        &.is-current {
            color: $step-color-current;

            .payroll-step-number {
                background-color: $step-color-current;
            }
        }

        + .payroll-step {
            margin-left: 1.5rem;
        }
    }
    .payroll-step-number {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: $step-line-height * 2;
        height: $step-line-height * 2;
        margin-right: 0.625rem;
        border-radius: 50%;
        color: #fff;
        font-size: 1.125rem;
        font-weight: 700;
        line-height: 1;
    }
    .payroll-step-label {
        font-size: 0.875rem;
        font-weight: 500;
        line-height: $step-line-height;
    }
    .payroll-step-label-line {
        display: block;
    }
</style>
